
// src/utils/i18nContent.js

/**
 * Return a 2-letter language code.
 */
export const langShort = (lng) => (lng || '').slice(0, 2);

/**
 * Safely pick a localized string from either:
 * - a plain string (legacy FR)
 * - an object map { fr, en, nl, ... }
 * Falls back to the provided fallback (default 'fr').
 */
export const pickL = (objOrString, lng = 'fr', fallback = 'fr') => {
  if (!objOrString) return '';
  if (typeof objOrString === 'string') return objOrString;
  const short = langShort(lng);
  return objOrString[lng] || objOrString[short] || objOrString[fallback] || '';
};

/**
 * Returns true when we are showing the fallback language instead of the target one.
 */
export const isFallback = (objOrString, lng = 'fr', fallback = 'fr') => {
  if (!objOrString) return false;
  if (typeof objOrString === 'string') return lng !== fallback;
  const short = langShort(lng);
  const hasTarget = !!objOrString[lng] || !!objOrString[short];
  return !hasTarget && !!objOrString[fallback];
};

/**
 * Helper for documents that follow the pattern:
 *  - field (legacy FR string)
 *  - field_i18n (object map { fr, en, nl })
 * It returns the right value with fallback.
 */
export const pickDocField = (doc, baseField, lng = 'fr', fallback = 'fr') => {
  if (!doc) return '';
  const i18nField = doc[`${baseField}_i18n`];
  const legacy = doc[baseField];
  return pickL(i18nField ?? legacy, lng, fallback);
};

/**
 * Category helper:
 * Accepts:
 *  - string (legacy)
 *  - { id, label: { fr, en, nl } }
 *  - { id, label: "Some string" }
 */
export const pickCategoryLabel = (category, lng = 'fr', fallback = 'fr') => {
  if (!category) return '';
  if (typeof category === 'string') return category;
  if (typeof category.label === 'string') return category.label;
  if (category.label && typeof category.label === 'object') {
    return pickL(category.label, lng, fallback);
  }
  return category.id || '';
};
